export const isReady = state => state.packages.isReady
export const hasError = state => state.packages.hasError === true
export const getErrorMessage = state => state.packages.errorMessage
export const getPackageIds = state => state.packages.packages
export const getPackagesById = state => state.packages.packagesById
export const getFocusedPackageId = state => state.packages.focusedPackageId
export const getSelectedPackageId = state => state.packages.selectedPackageId
export const getPreviousPackageId = state => state.packages.previousPackageId
export const getDetailsFocused = state => state.packages.focusDetails
export const getPackage = (id, state) => state.packages.packagesById[id]
export const getPackageDetails = state => id => state.packages.packagesById[id]
export const paypalSubscriptionError = state => state.packages.paypalSubscriptionError

export const getCurrentPackage = state => {
  if (state.packages.packages.length === 0) {
    return null
  }

  let targetId
  if (state.packages.focusedPackageId > 0) {
    targetId = state.packages.focusedPackageId
  } else if (state.packages.previousPackageId > 0) {
    targetId = state.packages.previousPackageId
  } else if (state.packages.selectedPackageId > 0) {
    targetId = state.packages.selectedPackageId
  } else {
    return undefined
  }

  return state.packages.packagesById[targetId]
}

export const getPackages = state => {
  const packageIds = getPackageIds(state)
  const packagesById = getPackagesById(state)
  return packageIds.map(id => packagesById[id])
}
